module.exports = __webpack_public_path__ + "img/europa.6dd7e43c.png";